module.exports = __webpack_public_path__ + "static/backdrop-top-2c471ec080b5e4bd2ac01ddad0d9cce7.jpg";